
import React from "react";
import { Building2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Separator } from "@/components/ui/separator";
import { useValidation } from "@/contexts/ValidationContext";

interface BusinessInfoStepProps {
  businessData: {
    name: string;
    industry: string;
    description: string;
  };
  updateBusinessData: (key: string, value: string | string[]) => void;
}

const BusinessInfoStep: React.FC<BusinessInfoStepProps> = ({ 
  businessData, 
  updateBusinessData 
}) => {
  const { getFieldError } = useValidation();
  const nameError = getFieldError('name');
  const industryError = getFieldError('industry');

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-2 mb-4">
        <Building2 className="text-primary h-6 w-6" />
        <h3 className="text-2xl font-medium">Business Information</h3>
      </div>
      
      <Separator />

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="business-name">Business Name <span className="text-red-500">*</span></Label>
          <Input
            id="business-name"
            placeholder="Acme Inc."
            value={businessData.name}
            onChange={(e) => updateBusinessData("name", e.target.value)}
            className={nameError ? "border-red-500" : ""}
          />
          {nameError && (
            <p className="text-red-500 text-sm mt-1">{nameError}</p>
          )}
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="industry">Industry <span className="text-red-500">*</span></Label>
          <Input
            id="industry"
            placeholder="Technology, Healthcare, Education, etc."
            value={businessData.industry}
            onChange={(e) => updateBusinessData("industry", e.target.value)}
            className={industryError ? "border-red-500" : ""}
          />
          {industryError && (
            <p className="text-red-500 text-sm mt-1">{industryError}</p>
          )}
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="description">Business Description (Optional)</Label>
          <Textarea
            id="description"
            placeholder="Tell us what your business does..."
            className="resize-none"
            rows={4}
            value={businessData.description}
            onChange={(e) => updateBusinessData("description", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessInfoStep;
